import React from "react";
import { About } from "../ui/CommonStyles";
import bioImage1 from "../img/about/BioImage1.jpg";
import bioImage2 from "../img/about/BioImage2.jpg";

function BioPage() {
  return (
    <About className="container">
      <div className="row">
        <div className="col-md-4 col-sm-5 col-xs-12">
          {/* TODO: add scroll through image viewer */}
          <div className="thumbnail">
            {/* <div
                className="image pic1"
                style={{ backgroundImage: "url(" + bioImage1 + ")" }}
              /> */}
            <img src={bioImage1} alt="kendel at show" className="image-bio" />
          </div>
        </div>
        <div className="col-md-4 col-sm-7 col-xs-12">
          <h1>about me</h1>
          <p className="bio-text">
            My name is Kendel and I am the artist behind Lupine Raven Artworks!
          </p>
          <p className="bio-text">
            Nature has always been a passion of mine. Whether it's painting
            landscapes of places I've been, or capturing the essence of animals
            I love. I have a huge heart for critters big and small. Especially
            the ones that are misunderstood.
          </p>
          <p className="bio-text">
            I'm a bird nerd, bird watcher, I love traveling, hiking, exploring,
            practicing my photography, and just being outside in general.
            Adventures with my husband and our dogs are my absolute favorite
            thing.
          </p>
          <p className="bio-text">
            I'm always trying new things with my art and experimenting with
            different mediums. Some of my favorites are watercolor, digital, and
            acrylic, but I also work with graphite, colored pencil, and
            printmaking as well!
          </p>
          <p className="bio-text">
            Art has this amazing ability to connect people and inspire. My goal
            with art is to inspire everyone to see the beauty and importance of
            the creatures we share this planet with.
          </p>
          <p className="bio-text">
            Thank you for being here and supporting my work! I love connecting
            with you guys and geeking out over all things nature. It makes me so
            happy to know my art has resonated with you.
          </p>
          {/* <p className="bio-text">
            Hey there! My name is Kendel and I'm a mixed media artist living in Reno, Nevada. 
            I create artwork inspired by things I find beautiful and interesting in nature. 
            I am passionate about shining light on creatures that are misunderstood like rats, mice, snakes, ravens, crows, pigeons, etc. 
            I have pet rats of my own that show up in my work often! My favorite mediums to work with are watercolor, ink, acrylic and digital. 
          </p>
          <span role="img" aria-label="heart">
              ❤️
          </span>
          <p className="bio-text">
            In my free time you'll find me gardening, traveling, playing video games, taking care of my plants and animals, 
            and exploring the Reno/Tahoe area with my partner and our dog, Kai.
          </p> */}
        </div>
        <div className="col-md-4 col-sm-5 col-xs-12">
          <div className="thumbnail">
            {/* <div
              className="image pic1"
              style={{ backgroundImage: "url(" + bioImage2 + ")" }}
            /> */}
            <img
              src={bioImage2}
              alt="kendel and jupiter"
              className="image-bio"
            />
          </div>
        </div>
      </div>
    </About>
  );
}

export default BioPage;
